// Helper functions converted from Handlebars helpers

/**
 * Checks if either DDL or JSON service is available.
 * @param ddlService - Is DDL service available?
 * @param jsonService - Is JSON service available?
 * @returns true if either is available, false otherwise
 */
export function chkIfServiceAvailable(
  ddlService?: boolean,
  jsonService?: boolean
): boolean {
  return !!(jsonService || ddlService);
}

/**
 * Checks if both FreeHeading and FreePhone fields are not null or empty.
 * @param FreeHeading - Heading string
 * @param FreePhone - Phone string
 * @returns true if both are present, false otherwise
 */
export function chkFieldValue(
  FreeHeading?: string | null,
  FreePhone?: string | null
): boolean {
  return !!(FreeHeading && FreePhone);
}
